export default __webpack_public_path__ + "static/media/ici.a459c301.svg";